import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, NotificationService } from '../../../../tms-shared';
import { AddressAddressee } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class AddressAddresseeService extends TmsWebBaseEditCreateService<AddressAddressee, AddressAddressee> {
  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('AddressAddressee', $localize`Address Addressee`, httpService, notificationService);
  }

  getForAddress(id: string): Observable<AddressAddressee[]> {
    return this.httpService.get<AddressAddressee[]>(`${this.apiUrl}/AddresseesForAddress?id=${id}`);
  }
}
